export default function isPowerOfTwo(x) {
    return (Math.log(x)/Math.log(2)) % 1 === 0;
}